import React from 'react'
import { useSelector } from 'react-redux'
import { localeCountryIsUK, localeCountryIsFrance, localeLanguageIsFrench } from '.'
import { selectLocale } from '../../store/navigation/navigation.selectors'

/* eslint-disable react/display-name */
export const withFrenchSite = Component => props => {
  const locale = useSelector(selectLocale)

  return localeCountryIsFrance(locale) ? <Component {...props} /> : <></>
}

export const withFrenchLanguage = Component => props => {
  const locale = useSelector(selectLocale)

  return localeLanguageIsFrench(locale) ? <Component {...props} /> : <></>
}

export const withoutEnglishSite = Component => props => {
  const locale = useSelector(selectLocale)

  return !localeCountryIsUK(locale) ? <Component {...props} /> : <></>
}
